/**
 * @file KeyboardAvoidingView atom — keyboard-aware container primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/KeyboardAvoidingView
 */
export { KeyboardAvoidingView } from "@/components/ui/keyboard-avoiding-view";
